import React from 'react'
import './index.less'
import cdn from 'src/helper/cdn'
import { isRtl } from 'src/helper/tool'

import lang from '../lang'

export default class extends React.Component {
  state = {}

  constructor(props) {
    super(props)
  }

  componentDidMount() {}

  componentWillReceiveProps(e) {}

  render() {
    let {
      language,
      lang,
      admins,
      setIncludeOwner,
      cancelReward,
      includeOwner,
      canSelectOwner,
      UpdateRewordMembers,
      setOrder,
      otherDgid,
      otherGid
    } = this.props
    return (
      <div className="awardUserList">
        <div className="title">{lang.order}</div>

        {(!admins || admins.length == 0) && (
          <div className="empty">
            {<img src={`/img/app/roomsupport/empty3.png`} className="logo2" />}
            <div className="txt">{lang.noadmin}</div>
          </div>
        )}

        {admins.map((item, index) => {
          if (item.canSelect == 1) {
            return (
              <div
                className="content"
                onClick={() => {
                  setOrder(item.uid)
                }}
              >
                <img src={`${cdn(item.avatarurl)}`} className="logo" />
                <div className={`item w1 ${isRtl(language) && 'arlang'}`}>
                  <div className="center">
                    <div className="name">{item.nickname}</div>
                    {/* <div className="lv">
                    {item.wealthLv}
                  </div> */}
                  </div>
                  <div className="id">ID:{item.duid}</div>
                </div>
                <div className={`sort ${item.idx > 0 ? 'sort2' : ''}`}>{item.idx > 0 ? item.idx : ''}</div>
              </div>
            )
          }
        })}

        {admins.map((item, index) => {
          if (item.canSelect != 1) {
            return (
              <div className="content bg1">
                <img src={`${cdn(item.avatarurl)}`} className="logo" />
                <div className={`item w2 ${isRtl(language) && 'arlang'}`}>
                  <div className="center">
                    <div className="name">{item.nickname}</div>
                    {/* <div className="lv">
                    {item.wealthLv}
                  </div> */}
                  </div>
                  <div className="id">ID:{item.duid}</div>
                </div>
                <div className={`remark ${isRtl(language) && 'arlang'}`}>
                  {item.canSelect == 2 && lang.lvLow}
                  {item.canSelect == 3 && lang.otherRoom.replace('AAA', item.otherDgid)}
                </div>
              </div>
            )
          }
        })}

        <div className="ownerGet">
          <div className="des">{lang.ownerGet}</div>

          {includeOwner && (
            <div
              className="btnC"
              onClick={() => {
                setIncludeOwner()
              }}
            >
              <img src="/img/app/roomsupport/open.png" />
            </div>
          )}

          {!includeOwner && (
            <div
              className="btnC"
              onClick={() => {
                setIncludeOwner()
              }}
            >
              <img src="/img/app/roomsupport/close.png" />
            </div>
          )}
        </div>

       {/*  <div className="cancelAdmin">
          <div>{!canSelectOwner && otherGid > 0 && lang.cancelAdmin.replace('AAA', otherDgid)}</div>
          {!canSelectOwner && otherGid > 0 && <div
              className="btnC"
              onClick={() => {
                cancelReward(otherGid)
              }}
            >
              <img src="/img/app/roomsupport/open.png" />
            </div>}
         </div> */}

        <div
          className="btn"
          onClick={() => {
            UpdateRewordMembers()
          }}
        >
          {lang.modify}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/roomsupport-op/AwardUserList/index.js